import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { SettingsAsObject, SettingsParamValue } from '@core/models/settings.model';
import { RouteEntity } from '@core/router/router.entity';
import { AppState } from '@core/state/app.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


export const settingsGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
    const appState: AppState = inject(AppState);
    const router: Router = inject(Router);

    return appState.settings$.pipe(
        map((settings: SettingsAsObject) => {
            if (state.url.includes(RouteEntity.Root + RouteEntity.Basket) && settings.CLIENT_TICKET_REG !== SettingsParamValue.Y) {
                router.navigate([RouteEntity.Root, RouteEntity.Tickets]);

                return false;
            }

            if (state.url.includes(RouteEntity.Root + RouteEntity.Topup) && settings.CLIENT_WALLET_REG !== SettingsParamValue.Y) {
                router.navigate([RouteEntity.Root, RouteEntity.Tickets]);

                return false;
            }

            return true;
        }),
    );
};
